// src/api/config.js
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";

export { API_BASE_URL };
